import { Box, Typography } from "@mui/material";

export default function Page404() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
        textAlign: "center",
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom color="error">
        403
      </Typography>
      <Typography variant="h6" component="p">
        User doesn't have permissions
      </Typography>
    </Box>
  );
}

